<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onBack" />
      </template>
      源泉徴収票の発行
    </Header>

    <div class="withholding-corporation px-3 py-4">
      <div
        v-if="slipList.length > 0"
        class="withholding-list bg-white border border-outline-color px-3 mt-3 round-4"
      >
        <div v-for="slip in slipList" :key="slip.id" class="withholding-item">
          <a
            target="_blank"
            role="button"
            class="d-flex justify-content-between align-items-center py-3"
            @click="downloadPdf(slip)"
          >
            <p class="text-black text-size-14 text-weight-500">
              {{ slip.name }}
            </p>
            <FeatherIcon icon="chevron-right" class="text-gray-05" />
          </a>
        </div>
      </div>
      <div v-else>
        <p class="text-size-14 text-center mt-3">
          勤務完了したお仕事がありません
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-facing-decorator";
import { accountService } from "@/app/services/AccountService";
import { authService } from "@/app/services/AuthService";
import { withholdingService } from "@/app/services/WithholdingService";
import { APP_API_URL_BASE } from "@/const/app";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { SnapshotCorporation } from "@/types/withholding/SnapshotCorporation";
import { showErrorModal } from "@/utils/showErrorModal";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const cordova: any;

@Component({
  components: {
    FeatherIcon,
    Header
  }
})
export default class SlipList extends Vue {
  slipList: SnapshotCorporation[] = [];

  get year() {
    return Number(this.$route.params.year);
  }

  async created() {
    try {
      this.$loading.show();
      // アカウント情報を更新
      await accountService.updateUserData();
      const user = authStore.user!;
      this.slipList = await withholdingService.fetchSlipList(
        this.year,
        user.username
      );
    } catch (e) {
      showErrorModal(this, e as Error);
    } finally {
      this.$loading.hide();
    }
  }

  getPdfUrl(token: string, slip: SnapshotCorporation) {
    const user = authStore.user!;
    return `${APP_API_URL_BASE}/withholdings/worker/slips/slips/pdf/?token=${token}&year=${this.year}&username=${user.username}&corporationId=${slip.corporationId}`;
  }

  async downloadPdf(slip: SnapshotCorporation) {
    try {
      this.$loading.show();
      const { token } = await authService.getImmediatelyExpiryToken();
      const url = this.getPdfUrl(token, slip);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((window as any).cordova !== undefined) {
        cordova.InAppBrowser.open(url, "_system");
        return;
      }
      window.open(url, "_blank");
    } catch (e) {
      showErrorModal(this, e as Error);
    } finally {
      this.$loading.hide();
    }
  }

  onBack() {
    this.$router.back();
  }
}
</script>

<style lang="scss" scoped>
.withholding-corporation {
  .link:hover,
  .link:active {
    text-decoration: underline;
  }

  .year-list {
    .year-link:not(:first-child) {
      border-top: 1px solid $outline-color;
    }
  }
}
</style>
